export const SupplierReferenceTypes = [
  { key: 'CR', value: 'Customer Reference(CR)' },
  { key: 'EQ', value: 'Equipment(EQ)' },
  { key: 'P8', value: 'Pickup Number(P8)' },
  { key: 'RA', value: 'Return Acceptance(RA)'},
  { key: 'SWG', value: 'Ship With Group(SWG)' },
  { key: 'TR', value: 'Trailer Reference(TR)' },
  { key: 'AO', value: 'Appointment Number(AO)' },
  { key: 'SO', value: 'Shipper’s Order(SO)' },
  { key: 'BM', value: 'Bill of Lading(BM)' }
];
